import React, { useRef } from 'react'
import Button, { TYPES } from 'components/Button'
import DropInVideoPlayer, { DEFAULT_CONTROLS } from 'components/DropInVideoPlayer'
import IconV2, { ICON_TYPES } from 'components/Icon.v2'
import { Map } from 'immutable'

/**
 * The announcemnt modal component
 * @param {Object} props - The props
 * @param {Map} props.staticText - The static text
 * @param {Function} props.onCloseClick - The handler function for close button
 * @param {Boolean} props.showButton - The prop indicating button should be displayed
 * @returns {JSX.Element} AnnouncementModal
 */
function AnnouncementModal (props) {
  const {
    staticText,
    onCloseClick,
    showButton,
    mediaId,
    buttonUrl,
  } = props

  const playerRef = useRef()

  const description = staticText.get('description') || null
  const heading = staticText.get('heading') || null
  const buttonText = staticText.get('button') || null

  /* ad hoc solution for the thank you announcement */
  const poster = 'https://brooklyn.gaia.com/v1/assets-render/4a90ea1c-3a23-4881-9fcc-e4d669b1086b?fm=webp&q=80&w=858&h=482'

  return (
    <div className="announcement-modal">
      {
        mediaId
          && <div className="announcement-modal__video-container">
            <DropInVideoPlayer
              autoplay={false}
              mediaId={mediaId}
              playsinline
              controls={{ type: DEFAULT_CONTROLS }}
              poster={poster}
              onPlayerSuccess={(data) => {
                playerRef.current = data.ref
              }}
            />
          </div>
      }
      <div className="announcement-modal__content">
        <Button type={TYPES.LINK} onClick={onCloseClick} className="announcement-modal__close" />
        { heading && <header className="announcement-modal__header">{heading}</header> }
        { description && <p className="announcement-modal__text">{description}</p>}
        {showButton && buttonText
          ? <>
            {buttonUrl
              ? <Button
                className="announcement-modal__button"
                type={TYPES.PRIMARY}
                onClick={onCloseClick}
                target={'_blank'}
                url={buttonUrl}
              >
                {buttonText}
                <IconV2 type={ICON_TYPES.CHEVRON_RIGHT} />
              </Button>
              : <Button
                className="announcement-modal__button"
                type={TYPES.PRIMARY}
                onClick={() => playerRef.current && playerRef.current.play()}
              >
                {buttonText}
              </Button>
            }
          </>
          : null
        }
      </div>
    </div>
  )
}

AnnouncementModal.defaultProps = {
  showButton: true,
  staticText: Map(),
}

export default AnnouncementModal
